let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3ncv5")).then(() => parcelRequire('7vGOX'));